if ($('.cc-table').length > 0) {
    const ccTable = $('.cc-table .table');
    const ccTableContainer = $('.cc-table #tableContainer');
    const ccTableBody = $('.cc-table #dynamicTableBody');
    const ccSearchInput = $('.cc-table .search-input');
    const resetButton = $('.cc-table .cc-reset');
    const searchButton = $('.cc-table .cc-search');
    const noResultsText = $('.cc-table .cc-no-results');

    resetButton.on('click', function (e) {
        e.preventDefault();
        ccSearchInput.val('');
        getCCData({});
    })

    searchButton.on('click', function (e) {
        e.preventDefault();
        ccSearchInput.val(normalizeInput(ccSearchInput.val(), false));

        if (ccSearchInput.val() !== '') {
            getCCData({'q': normalizeInput(ccSearchInput.val(), true)});
        }
    })

    ccSearchInput.on('keyup', function (e) {
        if (e.which === 13 && ccSearchInput.val() !== '') {
            searchButton.click();
        }
    })

    ccSearchInput.on('blur', function (e) {
        ccSearchInput.val(normalizeInput(ccSearchInput.val(), false));
    })

    const rohsImage = (data) => {
        let output = '';

        if (data.rohs && data.rohs === 'Lead-free') {
            output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rohs_pb.png" />`;
        } else {
            output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rohs_nopb.png" />`;
        }

        switch (data.rhf) {
            case "D":
                output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rhf_darkgreen.png" />`;
                break;
            case "E":
                output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rhf_exempted.png" />`;
                break;
            case "G":
                output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rhf_green.png" />`;
                break;
            case "H":
                output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rhf_halogen_antimonyfree.png" />`;
                break;
            case "N":
                output += `<img src="${window.location.origin + '' + ctxPath}/.resources/ampleon-theme/resources/images/cc/icon_rhf_non_rohs_compliant.png" />`;
                break;
        }

        return output;
    }

    const formatResponse = (data, fallback) => {
        return data ? data : fallback
    }

    const getCCData = function (attrs) {
        ccTableBody.empty();

        $.ajax({
            url: `${window.location.origin + ctxPath}/.rest/chemicalcontent/v1/cc`,
            method: 'GET',
            dataType: 'json',
            data: attrs,
            headers: {
                'Accept': 'application/json'
            },
            timeout: 10000
        })
            .done(function (data, textStatus, xhr) {
                if (xhr.status === 204) {
                    ccTableContainer.hide();
                    noResultsText.show();
                    $.tablesorter.destroy(ccTable, false);
                }

                if (data && 'items' in data && data.items.length > 0) {
                    ccTableContainer.show();
                    noResultsText.hide();
                    $.tablesorter.destroy(ccTable, false);

                    data.items.forEach(function (item) {
                        const tr = `<tr>
                    <td><a href="/pip/${item.typeNumber}">${item.typeNumber}</a></td>
                    <td>${formatResponse(item.opn, '-')}</td>
                    <td>${formatResponse(item.nc12, '-')}</td>
                    <td data-int>${formatResponse(item.msl, '-')}</td>
                    <td data-int>${formatResponse(item.ppt, '-')}</td>
                    <td data-int>${formatResponse(item.mppt, '-')}</td>
                    <td data-int>${formatResponse(item.cycles, '-')}</td>
                    <td class="cc-rohs"><a href="/about/quality/faq">${rohsImage(item)}</a></td>
                    <td><a href="/chemical-content/${item.typeNumber}.html">View</a></td>
                    </tr>`;
                        ccTableBody.append(tr);

                    })
                    $('.cc-table table.tablesorter').tablesorter({
                        headers: {
                            7: {sorter: false},
                            8: {sorter: false}
                        }
                    });
                }
            })
            .fail(function (xhr, textStatus, errorThrown) {
                console.error('ERROR', xhr.status, xhr.responseText || errorThrown);
            });
    };

    $('[data-toggle="tooltip"]').tooltip({container: 'body', html: false, trigger: 'hover'});

    const attrs = [{name: 'q', value: ''}];
    getCCData(attrs);
}
